import { forwardRef } from "react";
import { ReactComponent as SurveyIcon } from "../../../assets/icons/nav_survey.svg";
import { type SvgIconProps, useTheme } from "@mui/material";

const IconSurvey = forwardRef<SVGSVGElement, SvgIconProps>(
  function IconSurvey(props, ref) {
    const theme = useTheme();
    return (
      <SurveyIcon
        ref={ref}
        width="24px"
        height="24px"
        {...props}
        style={{
          padding: "2px",
          fill: theme.palette.text.primary,
        }}
      />
    );
  },
);

export default IconSurvey;
